import React, { useState } from "react";
import NuovaOrchestra from "../imgs/Nuova orchestra.jpg";
import Locandina from "../imgs/LocandinaScuola.jpg";
import Locandina9 from "../imgs/concerto9novembre.jpg";
import Locandina30 from "../imgs/concerto30novembre.jpg";
// import MilanoWindEnsemble from "../imgs/MilanoWindEnsemble.png";
// import LocandinaStelle from "../imgs/LocandinaSottoLeStelle.jpg";
// import LocandinaConcerto from "../imgs/LocandinaConcerto.jpg";
// import IrsinaConcerto from "../imgs/concerto-Irsina.jpg";

const Home = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);

  const handleImageClick = (image) => {
    setFullScreenImage(image);
  };

  const handleClose = () => {
    setFullScreenImage(null);
  };

  return (
    <div className="flex flex-col items-center z-10">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        NEWS
      </p>
      <div className="flex flex-col xs:text-xs md:text-base w-3/4 items-center bg-gradient-to-r from-white via-amber-100 to-white">
        <img src={NuovaOrchestra} />
        <p>La nuova orchestra di Milano ha in programma:</p>
        <div className="flex flex-col text-center items-center font-semibold">
          {/* <p>1.La Moldava di B. Smetana (per il duecentenario della nascita)</p> */}
          <p>1. 9 Novembre 2024 presso il Teatro Stella di Via Pezzotti</p>
          <p>
            2. 30 Novembre 2024 presso l'ex convento dell'Annunciata di
            Abbiategrasso
          </p>
          {/* <div className="flex flex-col items-center text-red-600">
            <p>concerto 22 giugno 2024 - Chiesa San. Maria in Zivido</p>
            <p>
              Direttore{" "}
              <a
                href="https://www.giuseppedinardo.it/"
                className="font-bold underline"
              >
                Giuseppe Dinardo
              </a>
            </p>
          </div> */}

          {/* <p className="text-center">
            2.Manon Lescaut - Intermezzo di G.Puccini (per il centenario della
            morte)
          </p> */}
          {/* <p>3.Peer Gynt Suite n. 1 di E. Grieg</p> */}
        </div>
      </div>

      <div className="flex flex-col justify-center items-center">
        <img src={Locandina} className="w-3/5" />
        <div className="flex justify-center w-3/5">
          <img
            src={Locandina9}
            className="w-2/5 cursor-pointer"
            onClick={() => handleImageClick(Locandina9)}
          />
          <img
            src={Locandina30}
            className="w-2/5 cursor-pointer"
            onClick={() => handleImageClick(Locandina30)}
          />
          {/* <img
            src={IrsinaConcerto}
            className="w-2/5 cursor-pointer"
            onClick={() => handleImageClick(IrsinaConcerto)}
          /> */}
        </div>
      </div>

      {fullScreenImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={handleClose}
        >
          <img src={fullScreenImage} className="max-w-full max-h-full" />
        </div>
      )}

      <div className="w-3/4 mt-8 xs:text-sm md:text-base">
        <p className="text-center">
          - MilArte è un'Associazione di Promozione Sociale dedicata alla
          musica, fondata nel 2023 con l'obiettivo di diffondere la passione per
          la musica e creare un impatto positivo nella comunità attraverso
          iniziative musicali significative. La visione di{" "}
          <a href="https://www.giuseppedinardo.it/" className="text-red-600">
            Giuseppe Dinardo
          </a>{" "}
          ha guidato la fondazione dell'associazione consolidando la sua
          presenza nel panorama musicale locale grazie alla dedizione dei membri
          e al sostegno della comunità.
        </p>
        <p className="mt-5 text-center">
          - Gli obiettivi principali di MilArte includono la proposta di
          concerti, eventi e manifestazioni varie, con la convinzione che la
          musica possa trasformare e arricchire la vita di tutti. L'associazione
          s'impegna instancabilmente per rendere la musica accessibile a un
          pubblico ampio. Le attività di MilArte comprendono programmi e
          iniziative volte a promuovere la cultura musicale e a coinvolgere la
          comunità in esperienze musicali significative.
        </p>
        <p className="mt-5 text-center">
          - In preparazione abbiamo anche visite e concerti nelle scuole, con
          l'ambizione di suscitare la meraviglia di fronte alla musica fatta con
          mani umane, e condividere dimensioni di senso e cultura con i giovani.
          Vorremmo essere Orchestra "Nuova" anche nell'accezione particolare di
          diffondere cultura e nutrire interiormente i nostri uditori.
        </p>
      </div>
    </div>
  );
};

export default Home;
